
import React, { Component } from 'react';
import './styles/player-controls-startover.css';
import ChannelInfoLabel from './common/ChannelInfoLabel';
import DirectLabel from './common/DirectLabel';
import TimeLabel from './common/TimeLabel';
import PlayerSlider from './common/PlayerSlider';
import VideoPlayerControl from './common/VideoPlayerControl';
import {
    CONTROL_RECORDING,
    CONTROL_TS_BACKWARD,
    CONTROL_SPEED_BACKWARD,
    CONTROL_PLAY,
    CONTROL_PAUSE,
    CONTROL_EPG,
    CONTROL_LANGUAGE,
    CONTROL_TS_FORWARD,
    CONTROL_SPEED_FORWARD

} from './common/constants';

import TrackerManager from '../../utils/TrackerManager';
import PlayerControlsLogic from './PlayerControlsLogic';
import Utils from '../../utils/Utils';
import ChannelStreamUtil from '../../utils/ChannelStreamUtil';
import { playerSettings } from './common/constants';
import FallbackUtil from '../../components/Video/FallbackUtil';
import TvChannelUtil from '../../utils/TvChannelUtil';
import ChannelSingleton from '../../components/Epg/ChannelsSingleton';
import EventTimeshift from '../../AAF/Timeshift/EventTimeshift';
import Translator from '../../requests/apa/Translator';
import { Grid, Row, Column, cls } from '../../packages/components';
import { AAF_CONTENT_IS_STARTOVER } from '../../AAFPlayer/constants';
import { utilsPlayersControls } from 'src/playerDomain/components/utils/index'
import { seekStartOver } from 'src/playerDomain/components/seeks/index'
import {
  updateValuesStorageMount,
  updateValuesStorageUnMount } from 'src/components/Modal/functions/ModalInactivity/index'
import store from '../../store';

class PlayerControlsStartover extends Component {

    constructor(props) {
        super(props);

        this.props = props;

        this.backward = this.backward.bind(this);
        this.forward = this.forward.bind(this);
        this.speedBackward = this.speedBackward.bind(this);
        this.speedForward = this.speedForward.bind(this);

        this.onExitForModalInactivity = this.onExitForModalInactivity.bind(this)
        this.play = this.play.bind(this);
        this.pause = this.pause.bind(this);
        this.getCurrentTime = this.getCurrentTime.bind(this);

        this.speedBackwardButtonTitle = Translator.get('playing_playerControls_toolbar_button_rewind', 'Atrasar') ;
        this.speedForwardButtonTitle = Translator.get('playing_playerControls_toolbar_button_forward', 'Adelantar');

        this.backwardButtonTitle = Translator.get('playing_playerControls_toolbar_button_seekTsRewind', 'Atrasar') ;
        this.forwardButtonTitle = Translator.get('playing_playerControls_toolbar_button_seekTsForward', 'Adelantar');

        this.defaultButtons = this.getDefaultButtons();

        this.addEventListeners = this.addEventListeners.bind(this);
        this.removeEventListeners = this.removeEventListeners.bind(this);

        this.slide = this.slide.bind(this);
        this.updateCurrentTimeUI = this.updateCurrentTimeUI.bind(this);
        this.updateCurrentTime = this.updateCurrentTime.bind(this);
        this.setTimeshiftEventInfo = this.setTimeshiftEventInfo.bind(this);
        this.onRateChange = this.onRateChange.bind(this);
        this.watchCurrentTime = this.watchCurrentTime.bind(this);
        this.exitTrickMode = this.exitTrickMode.bind(this);
        this.eventIsRecording = this.eventIsRecording.bind(this);

        this.seekInPause = 0;
        this.seekTime = 0;
        this.seekTotalTime = 0;
        this.currentTime = 0;

        this.state = {
            timeshiftEventInfo: null
        };


        this.switchingBetweenEventTimeshift = false;
        this.timerTimeshitDelayId = null;
        this.pendingStartoverOnPause = null;
        this.timeshiftTime = 0;
        this.liveWasPause = null;
        this.waitForSeconds = false;
        this.isInTrickMode = false;

        // Indica que el user se esta moviendo hacía atrás
        this.backwardIsMoving = false;
        this.delayTimeshiftSeek = 1000; //ms
        this.paramsModalInactivity = {
          pause: this.pause,
          play: this.play,
          exit : this.onExitForModalInactivity,
          clearLoading: this.props.clearLoading,
          toggleEPG: this.props.onEpg,
          goToLive: this.props.goToLive
        }
        this.modalInactivityEnabled = store.getState().modalInactivity.enabled;
        this.setIntervalModalInactivity = this.modalInactivityEnabled ? PlayerControlsLogic.setIntervalModalReproduction(this.paramsModalInactivity) : null;
    }

    onExitForModalInactivity(){
      updateValuesStorageUnMount(this.setIntervalModalInactivity)
      this.props.onExit()
    }

    getDefaultButtons() {
        const defaultButtons = [];

        if(this.isFastRewindEnable()) {
            defaultButtons.push({ type: CONTROL_SPEED_BACKWARD, clic: this.speedBackward, enabled: true, title: this.speedBackwardButtonTitle });
        } else {
            EventTimeshift.isSeekOnTSEnabled('startover') &&  defaultButtons.push({ type: CONTROL_TS_BACKWARD, clic: this.backward, enabled: true, title: this.backwardButtonTitle });
        }
        defaultButtons.push({ type: CONTROL_PLAY, clic: this.play, enabled: true, title: Translator.get('playing_playerControls_toolbar_button_play', 'Reproducir') });
        if(this.isFastRewindEnable()) {
            defaultButtons.push({ type: CONTROL_SPEED_FORWARD, clic: this.speedForward, enabled: true, title: this.speedForwardButtonTitle });
        } else {
            EventTimeshift.isSeekOnTSEnabled('startover') && defaultButtons.push({ type: CONTROL_TS_FORWARD, clic: this.forward, enabled: true, title: this.forwardButtonTitle });
        }
        defaultButtons.push({ type: CONTROL_EPG, clic: this.props.onEpg, enabled: true, title: Translator.get('playing_playerControls_toolbar_button_guide', 'Guía'), ref: null });
        defaultButtons.push({ type: CONTROL_LANGUAGE, clic: this.props.onLanguage, enabled: true, title: Translator.get('playing_playerControls_toolbar_button_language', 'Idioma') });

        return defaultButtons;
    }

    updateCurrentTime(currentTime) {
        this.setCurrentTime(currentTime);
        this.updateCurrentTimeUI();
    }

    setCurrentTime(currentTime) {
        this.currentTime = currentTime;
        this.watchCurrentTime(currentTime);
    }

    getCurrentTime() {
        let ct = this.backwardIsMoving ? this.timeshiftTime : this.currentTime;

        return ct;
    }

    hasTimeshift() {
        if (this.state.timeshiftEventInfo) {
            return (this.state.timeshiftEventInfo.event && !isNaN(this.state.timeshiftEventInfo.event.max_timeshift));
        }

        return false;
    }

    useTimeshiftEvent() {
        return (
            this.hasTimeshift() &&
            this.state.timeshiftEventInfo &&
            this.state.timeshiftEventInfo.event
        );
    }

    getDuration() {
        if (this.useTimeshiftEvent()) {
            if (this.state.timeshiftEventInfo && this.state.timeshiftEventInfo.event) {
                return (
                    this.state.timeshiftEventInfo.event.date_end -
                    this.state.timeshiftEventInfo.event.date_begin
                );
            }
        }

        return 0;
    }

    getBallPosition(ballPercent) {
        if (this.refs['playerSlider']) {
            const width = this.refs['playerSlider'].refs['barContainer'].offsetWidth;
            if (width < 1) return 0;
            const left = (width * ballPercent) / 100;

            return left;
        }

        return 0;
    }

    updateCurrentTimeUI() {

        const currentTimeUI = this.getCurrentTime();

        // El ancho de la barra del event progress
        let barEventPercent = 0;
        if (this.state.timeshiftEventInfo && this.state.timeshiftEventInfo.event) {
            barEventPercent = PlayerControlsLogic.getPercentProgressEvent(this.state.timeshiftEventInfo.event.date_begin, this.state.timeshiftEventInfo.event.date_end, this.getDuration());
        }

        // La posición del ball-slider del user progress
        const ballPercent = PlayerControlsLogic.getPercentProgress(currentTimeUI, this.getDuration());

        if (this.refs['playerSlider']) {
            // % barra avance, el now del usuario (puede ser el mismo que el now del programa)
            this.refs['playerSlider'].refs['progressNow'].style.width = ballPercent + '%';

            // % barra total, el now del programa (puede ser el mismo que el now del user)
            this.refs['playerSlider'].refs['progressTotal'].style.width = barEventPercent + '%';

            // Time start
            this.refs['timeStart'].refs['time'].innerHTML = PlayerControlsLogic.getCurrentTimeAsStringStartover(currentTimeUI, this.state.timeshiftEventInfo);

            // Ball position
            this.refs['playerSlider'].refs['ball'].style.left = this.getBallPosition(ballPercent) + 'px';
            // Time end
            this.refs['timeEnd'].refs['time'].innerHTML = PlayerControlsLogic.getDurationAsStringStartover(this.state.timeshiftEventInfo);
        }
    }

    /**
     * TODO revisar la condición
     */
    isRecordingEnabled() {
        return true;
    };

    /**
     * Resolve enabled buttons
     */
    getVisibleButtons() {
        const params = {
            defaultButtons : this.getDefaultButtons(),
            timeshiftEventInfo : this.state.timeshiftEventInfo,
            addValue : {
                type: CONTROL_RECORDING,
                clic: this.props.onRecording,
                enabled: true,
                title: Translator.get('playing_playerControls_toolbar_button_canRecord', 'Grabar') }
        }
        const auxDefaultButtons = this.props.addRecordingButton( params )

        let visible = auxDefaultButtons.map(
            (button) => {
                if (button.type === CONTROL_PLAY) {
                    if (this.props.playing) {
                        return { type: CONTROL_PAUSE, clic: this.pause, enabled: true, title:  Translator.get('playing_playerControls_toolbar_button_pause', 'Pausa') };
                    }
                    else {
                        // Por default el botón es play
                        return button;
                    }
                }
                else if (button.type === CONTROL_RECORDING) {
                    let buttonEnabled = null;
                    let buttonText = Translator.get('playing_playerControls_toolbar_button_canRecord', 'Grabar');
                    const recordingStatus = this.props.getEventRecordingStatus();
                    const recordingButton = document.querySelector(".video-player-control-button-recording");
                    switch (recordingStatus) {
                        case 0:
                            buttonEnabled = false;
                            buttonText = Translator.get('playing_playerControls_toolbar_button_canRecord', 'Grabar');
                            recordingButton && recordingButton.classList.remove("video-player-control-with-emphasis");
                            break;
                        case 1:
                            buttonEnabled = true;
                            buttonText = Translator.get('playing_playerControls_toolbar_button_canRecord', 'Grabar');
                            recordingButton && recordingButton.classList.remove("video-player-control-with-emphasis");
                            break;
                        case 2:
                            buttonEnabled = false;
                            buttonText = Translator.get('playing_playerControls_toolbar_button_Scheduled', 'Por grabar');
                            recordingButton && recordingButton.classList.add("video-player-control-with-emphasis");
                            break;
                        case 3:
                            buttonEnabled = true;
                            buttonText = Translator.get('playing_playerControls_toolbar_button_recordingBlink', 'Grabando');
                            recordingButton && recordingButton.classList.add("video-player-control-with-emphasis");
                            break;
                        case 4:
                            buttonEnabled = false;
                            buttonText = Translator.get('playing_playerControls_toolbar_button_inRecord', 'Grabado');
                            recordingButton && recordingButton.classList.add("video-player-control-with-emphasis");
                            break;
                        default:
                            break;
                    }

                    return { type: CONTROL_RECORDING, clic: this.props.onRecording, enabled: buttonEnabled, title: buttonText };
                }
                else
                    return button;
            }
        );

        // Cambio de idioma está disponible?
        if (!this.props.isMultipleLiveLangEnabled()) {
            visible = visible.filter(b => b.type !== CONTROL_LANGUAGE);
        }

        return visible;
    }

    addEventListeners() {
        this.removeEventListeners();
    }

    removeEventListeners() {
    }

    async componentDidMount() {
        await updateValuesStorageMount(AAF_CONTENT_IS_STARTOVER)
        this.addEventListeners();
    }

    resetLiveTimeshift() {
        this.pendingStartoverOnPause = null;
        this.timeshiftTime = 0;
        this.waitForSeconds = false;
        this.backwardIsMoving = false;
        this.switchingBetweenEventTimeshift = false;
        this.isInTrickMode = false;
    }

    componentWillUnmount() {
      this.resetLiveTimeshift();
      updateValuesStorageUnMount(this.setIntervalModalInactivity)
    }

    componentWillReceiveProps(nProps) {
        console.log('[NPC] Live cmponentWillReceiveProps ', nProps);
    }

    /**
   * Slider side actions
   * @param e
   */
    slide(e) {

        if(!EventTimeshift.isSeekOnTSEnabled('startover')) {
            return false;
        }

        if (!this.props.enabled) {
            return false;
        }

        console.log('[NPC] Startover slide events en 1, entrando', this.props.visible, this.props.playing);
        if (!this.props.visible) {
            return false;
        }

        this.props.onSlide(null, direction);

        console.log('[NPC] Startover slide events en 2');
        const { direction } = e.detail;
        switch (direction) {
            case 'left':
                e.preventDefault();
                if (this.isInTrickMode) {
                    this.exitTrickMode();
                }
                seekStartOver.calculateFinalSeekTime(true, playerSettings.getBackwardTimeByStreamtypeTS(AAF_CONTENT_IS_STARTOVER), this);
                break;
            case 'right':
                e.preventDefault();
                if (this.isInTrickMode) {
                    this.exitTrickMode();
                }
                // Si no esta en pausa, live no se mueve hacía adelante
                seekStartOver.calculateFinalSeekTime(false, playerSettings.getForwardTimeByStreamtypeTS(AAF_CONTENT_IS_STARTOVER), this);
                break;
            default:
                break;
        }
    }

    /**
        * Controles del player
        */
    play() {
        if (!this.props.enabled) return;
        if (this.isInTrickMode) {
            this.exitTrickMode();
            this.props.onPlay(() => {
                this.props.focus('.video-player-control-main-button-pause');
            });

            return;
        }

        return this.handleStartOverWithPlay();
    }

    handleStartOverWithPlay() {
        // Si no hice nada, sólo pausa y luego play, me
        // voy a ese segundo en dónde hice la pausa
        if (this.timeshiftTime === 0) {
            this.timeshiftTime = this.pendingStartoverOnPause;
        }

        let seekTo = this.timeshiftTime;

        // Do extra stuff when pause device
        this.props.onPlay(() => {
            this.focusSlider('.video-player-control-main-button-pause');
        });
        this.props.play();
        let timeshiftData = {
            timeshiftEvent: Object.assign({}, this.state.timeshiftEventInfo.event),
            backward: true,
            seektime: seekTo,
            maxtimeshiftallowed: this.state.timeshiftEventInfo.channelTimeshiftAllowed,
            timeshiftDelay: null
        };

        utilsPlayersControls.performTimeshift(timeshiftData, this);
        this.resetLiveTimeshift();
        // TODO ajustar auto hide
        // this.forceStopAutoHide = false;
        // this.verifySetAutoHide();
    }

    pause() {
        if (!this.props.enabled) return;
        return this.handleStartOverWithPause();
    }

    /**
    * Nueva experiencia timeshift
    */
    handleStartOverWithPause() {
        if (this.props.enabled) {
            this.pendingStartoverOnPause = this.getCurrentTime();
            this.timeshiftTime = this.pendingStartoverOnPause;
            this.backwardIsMoving = true;
            this.props.pause();
            this.props.onPause(this.getCurrentTime(), () => {
                this.props.focus('.video-player-control-main-button-play');
            });
        }
        // TODO verificar autohide
        // this.forceStopAutoHide = false;
        // this.verifySetAutoHide();
    }

    isFastRewindEnable() {
        return EventTimeshift.isTrickModeEnabled();
    }

    backward() {
        if (!this.props.enabled) return;
        this.props.onBackward(null);
        seekStartOver.calculateFinalSeekTime(true, playerSettings.getBackwardTimeByStreamtypeTS(AAF_CONTENT_IS_STARTOVER), this);
    }

    /**
     * backward en startover es trick mode x2 x4 ...
     * sólo slider-ball hace back y forward sobre el progress del evento
     */
    speedBackward() {
        // Reset autohide
        this.props.onBackward(null);
        if (!this.props.enabled) return;

        if (this.isFastRewindEnable()) {
            // Si player no cargó el video
            if (!this.props.enabled) return;

            if (this.props.playing || this.isInTrickMode) {
                this.props.speedBackward();
            }
            else {
                this.pendingStartoverOnPause = null;
                this.backwardIsMoving = false;
                this.timeshiftTime = 0;
                this.props.play();
                this.props.onPlay(() => {
                    this.props.speedBackward();
                });
            }
        }
    }

    forward() {
        if (!this.props.enabled) return;
        this.props.onForward(null);
        seekStartOver.calculateFinalSeekTime(false, playerSettings.getForwardTimeByStreamtypeTS(AAF_CONTENT_IS_STARTOVER), this);
    }

    /**
     * forward en startover es trick mode x2 x4 ...
     * sólo slider-ball hace back y forward sobre el progress del evento
     */
    speedForward() {
        // Reset autohide
        this.props.onForward(null);
        if (!this.props.enabled) return;

        if (this.isFastRewindEnable()) {
            // Si player no cargó el video
            if (!this.props.enabled) return;

            if (this.props.playing || this.isInTrickMode) {
                this.props.speedForward();
            }
            else {
                this.pendingStartoverOnPause = null;
                this.backwardIsMoving = false;
                this.timeshiftTime = 0;

                this.props.play();
                this.props.onPlay(() => {
                    this.props.speedForward();
                });
            }
        }
    }

    focusSlider() {
        const resultFocus = this.props.focus('.player-slider-bar-ball');
        if (!resultFocus) {
            //this.focusPlayPauseButton();
        }
    }

    focusPlayPauseButton(btnClass) {
        this.props.focus(btnClass);
    }

    getSafeTime() {
        const timeshiftMetadata = Utils.getApaMetadataKey('epg_event_safe_time', '{}', 'timeshift');

        if (timeshiftMetadata) {
            return timeshiftMetadata.start;
        }
        else {
            return 0;
        }
    }

    setOperatorsSeek(values) {
        this.valuesSeek = { ...values };
    }

    getOperatorsSeek() {
        return this.valuesSeek;
    }

    setTimeshiftEventInfo(timeshiftEventInfo) {
        this.resetLiveTimeshift();
        this.switchingBetweenEventTimeshift = false;
        /**
        * Evento a playear
        */
        let timeshiftAllowed = 0, channelNumber = '', channelImage = '', eventTitle = '';
        const groupId = timeshiftEventInfo && timeshiftEventInfo.event ? timeshiftEventInfo.event.group_id : '';

        if (groupId) {
            const channelInfo = ChannelStreamUtil.get(groupId);
            channelNumber = channelInfo ? channelInfo.channel_number || '' : '';
            channelImage = channelInfo ? channelInfo.imageEpg || '' : '';
            timeshiftAllowed = ChannelSingleton.getTimeshift(groupId, true);
            timeshiftEventInfo.channelTimeshiftAllowed = timeshiftAllowed;
        }
        eventTitle = timeshiftEventInfo && timeshiftEventInfo.event && timeshiftEventInfo.event.name ? timeshiftEventInfo.event.name : '';
        this.setState({ timeshiftEventInfo }, () => {
            this.updateChannelInfo(channelNumber, channelImage, eventTitle);
        });
    }

    /**
     * Update channel info
     */
    updateChannelInfo(channelNumber, channelIcon, eventTitle) {
        if (this.refs['channelInfoLabel']) {
            if (this.refs['channelInfoLabel'].refs['channelNumber']) this.refs['channelInfoLabel'].refs['channelNumber'].innerHTML = channelNumber;
            if (this.refs['channelInfoLabel'].refs['channelImageUrl']) this.refs['channelInfoLabel'].refs['channelImageUrl'].src = channelIcon;
            if (this.refs['channelInfoLabel'].refs['channelEventTitle']) this.refs['channelInfoLabel'].refs['channelEventTitle'].innerHTML = Utils.cutPlayerString(eventTitle, 30, 28);

            if(channelIcon) {
                this.refs['channelInfoLabel'].refs['channelImageUrl'] && this.refs['channelInfoLabel'].refs['channelImageUrl'].classList.remove('channel-info-label-image-hide');
             }
        }
    }

    onSeekStartOver(seekWasTo) {
        this.switchingBetweenEventTimeshift = false;
        console.log('[NPC] Startover function onSeekStartOver ' + this.switchingBetweenEventTimeshift);
    }

    /**
   * params = {speed: number, direction: FORWARD|BACKWARD}
   * @param speed
   * @param direction
   * @param frompause
   */
    onRateChange(speed, direction, frompause) {
        speed = Math.abs(speed);
        speed = speed + '';

        let refBackward = `video_control_type_${CONTROL_SPEED_BACKWARD}`;
        let refForward = `video_control_type_${CONTROL_SPEED_FORWARD}`;

        let refBackwardTitle = `video_control_title_${CONTROL_SPEED_BACKWARD}`;
        let refForwardTitle = `video_control_title_${CONTROL_SPEED_FORWARD}`;

        let trickBackward = null;
        let trickForward = null;

        if (this.refs[refBackward] && this.refs[refBackward].refs[refBackwardTitle]) {
            trickBackward = this.refs[refBackward].refs[refBackwardTitle];
        }

        if (this.refs[refForward] && this.refs[refForward].refs[refForwardTitle]) {
            trickForward = this.refs[refForward].refs[refForwardTitle];
        }

        if (!trickBackward || !trickForward) return;

        if (speed != 0) {
            this.isInTrickMode = true;
            if (direction === 'FORWARD') {
                trickBackward.innerText = this.speedBackwardButtonTitle;
                trickForward.innerText = this.speedForwardButtonTitle + ' x' + speed;

                // Se pone botón de play en lugar de botón de pausa
                this.props.onPause(this.getCurrentTime, () => {
                    this.props.focus('.video-player-control-button-forward');
                });
            }
            if (direction === 'BACKWARD') {
                trickForward.innerText = this.speedForwardButtonTitle;
                trickBackward.innerText = this.speedBackwardButtonTitle + ' x' + speed;

                // Se pone botón de play en lugar de botón de pausa
                this.props.onPause(this.getCurrentTime, () => {
                    this.props.focus('.video-player-control-button-backward');
                });
            }
        }
        else {
            this.isInTrickMode = false;
            trickBackward.innerText = this.speedBackwardButtonTitle;
            trickForward.innerText = this.speedForwardButtonTitle;

            // Se pone botón de pausa en lugar de botón de play
            this.props.onPlay(this.getCurrentTime, () => {
                this.props.focus('.video-player-control-main-button-pause');
            });
        }
    }

    watchCurrentTime(currentTime) {
        if (this.isInTrickMode && currentTime <= 1) {
            this.props.resetAutoHideTimer();
            // break trickmode
            this.exitTrickMode();
        }
    }

    /**
   * Reset trick mode to 0
   */
    exitTrickMode() {
        // Romper el trickmode
        this.props.setSpeed(0);
        // TODO ajustar AUTOHIDE
        // this.forceStopAutoHide = false;
        // this.verifySetAutoHide();
    }

    eventIsRecording() {
        return this.props.eventIsRecording();
    }

    render() {
        console.log('[NPC2] PC TV render ');
        const visibleButtons = this.getVisibleButtons();

        let defLength = 3;
        let controlsClassName = '';
        if(Array.isArray(visibleButtons)) {
            defLength = visibleButtons.length;
            controlsClassName = `player-controls-width-${defLength}`;
        }
        let ct = 1;

        return (
            <div>
                <Grid className="player-controls-startover-container">
                    <Row className="player-controls-startover-channelinfo-wrapper">
                        <ChannelInfoLabel ref="channelInfoLabel" />
                    </Row>

                    <div className="player-controls-startover-flex-slider-wrapper">
                        <Column lg={1} className={cls(``)}>
                            <TimeLabel ref="timeStart" />
                        </Column>
                        <Column lg={9} className={cls(``)}>
                            {/* La barra Bar Total es la que muestra en un startover, la que muestra el progress del evento respecto al now.  */}
                            <PlayerSlider
                                ref="playerSlider"
                                withBarTotal={true} // La barra que indica el total que lleva el programa a este momento
                                slide={this.slide}
                                ballPercent={this.props.ballPercent}
                            />
                        </Column>
                        <Column lg={1} className={cls(``)}>
                            <TimeLabel customCss="time-label-custom-end" ref="timeEnd" />
                        </Column>
                        <Column lg={1} className={cls(``)}>
                            <DirectLabel type="aaf_content_is_startover" label={Translator.get('playingLive_eventType_description_presentEvent_label', 'AHORA')} />
                        </Column>
                    </div>
                    <Row>
                        <div className="player-controls-startover-separator"></div>
                    </Row>
                </Grid>
                <Grid className={cls(`player-controls-startover-no-grid-float`)}>
                    <Row className={cls(`player-controls-startover-flex-controls-wrapper ${controlsClassName}`)}>

                        {
                            visibleButtons.map((button, idx, items) => <VideoPlayerControl
                                control={button}
                                onClic={button.clic}
                                key={`control_${ct++}`}
                                data={`video_control_type_${button.type}`}
                                ref={`video_control_type_${button.type}`}
                                isRecorded={this.eventIsRecording}
                                id={`pc${idx}`}
                                nav={this.props.getPlayerControlsButtonNavigation(idx, items, true)}
                            />
                            )
                        }
                    </Row>
                </Grid>
            </div>
        )
    }
}

export default PlayerControlsStartover;



// WEBPACK FOOTER //
// ./src/playerDomain/components/PlayerControlsStartover.js